'use client';

import React, { useState, useEffect } from 'react';
import TrackingHeader from './TrackingHeader';
import ProgressTimeline from './ProgressTimeline';
import TechnicianProfile from './TechnicianProfile';
import EstimatedCompletion from './EstimatedCompletion';
import CommunicationPortal from './CommunicationPortal';
import QualityCheckpoints from './QualityCheckpoints';

interface TrackingInteractiveProps {
  repairData: any;
}

const TrackingInteractive = ({ repairData }: TrackingInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    setIsHydrated(true);
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }));
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:38:6" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="38" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
        <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:39:8" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="39" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:40:10" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="40" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20space-y-6%22%7D" className="animate-pulse space-y-6">
            <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:41:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="41" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-32%20bg-muted%20rounded-xl%22%7D" className="h-32 bg-muted rounded-xl"></div>
            <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:42:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="42" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-3%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:43:14" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="43" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%20space-y-6%22%7D" className="lg:col-span-2 space-y-6">
                <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:44:16" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="44" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-muted%20rounded-xl%22%7D" className="h-96 bg-muted rounded-xl"></div>
                <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:45:16" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="45" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-64%20bg-muted%20rounded-xl%22%7D" className="h-64 bg-muted rounded-xl"></div>
              </div>
              <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:47:14" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="47" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
                <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:48:16" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="48" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-80%20bg-muted%20rounded-xl%22%7D" className="h-80 bg-muted rounded-xl"></div>
                <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:49:16" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="49" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-48%20bg-muted%20rounded-xl%22%7D" className="h-48 bg-muted rounded-xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>);

  }

  const mockTimelineSteps = [
  {
    id: '1',
    title: 'Device Received',
    description: 'Your iPhone 14 Pro has been received and logged into our system. Initial inspection completed.',
    status: 'completed' as const,
    timestamp: '10:30 AM',
    technician: 'Sarah Chen',
    image: "https://images.unsplash.com/photo-1695735187454-b41e943a213e",
    imageAlt: 'Technician examining iPhone 14 Pro on clean white workbench with diagnostic tools'
  },
  {
    id: '2',
    title: 'Diagnostic Testing',
    description: 'Comprehensive diagnostic tests completed. Screen replacement and battery calibration required.',
    status: 'completed' as const,
    timestamp: '11:15 AM',
    technician: 'Sarah Chen',
    image: "https://images.unsplash.com/photo-1642780144024-348fdc62939d",
    imageAlt: 'Close-up of diagnostic equipment testing iPhone components with colorful test results on screen'
  },
  {
    id: '3',
    title: 'Parts Procurement',
    description: 'Genuine Apple screen and battery components have been sourced and verified for compatibility.',
    status: 'completed' as const,
    timestamp: '12:00 PM',
    technician: 'Sarah Chen'
  },
  {
    id: '4',
    title: 'Screen Replacement',
    description: 'Currently replacing the damaged screen with genuine Apple components. Estimated completion in 45 minutes.',
    status: 'current' as const,
    timestamp: currentTime,
    technician: 'Sarah Chen',
    image: "https://images.unsplash.com/photo-1638495637353-b62161bece27",
    imageAlt: 'Skilled technician carefully installing new iPhone screen using precision tools under bright LED lighting'
  },
  {
    id: '5',
    title: 'Battery Calibration',
    description: 'Battery replacement and calibration to ensure optimal performance and longevity.',
    status: 'pending' as const,
    technician: 'Sarah Chen'
  },
  {
    id: '6',
    title: 'Quality Testing',
    description: 'Comprehensive quality checks including functionality, calibration, and stress testing.',
    status: 'pending' as const,
    technician: 'Sarah Chen'
  },
  {
    id: '7',
    title: 'Final Inspection',
    description: 'Final inspection and packaging for pickup or delivery.',
    status: 'pending' as const,
    technician: 'Sarah Chen'
  }];


  const mockTechnician = {
    id: '1',
    name: 'Sarah Chen',
    title: 'Senior Mobile Device Technician',
    experience: '8+ years',
    specialties: ['iPhone Repair', 'Screen Replacement', 'Water Damage', 'Battery Service'],
    rating: 5,
    completedRepairs: 2847,
    image: "https://images.unsplash.com/photo-1704455305620-21d29b7b63a0",
    imageAlt: 'Professional Asian woman technician with short black hair wearing blue lab coat smiling confidently',
    certifications: [
    'Apple Certified iOS Technician',
    'Mobile Device Hardware Specialist',
    'Advanced Diagnostics Certification',
    'Quality Assurance Level 3']

  };

  const mockMessages = [
  {
    id: '1',
    sender: 'technician' as const,
    message: 'Hi! I\'m Sarah, your technician. I\'ve received your iPhone 14 Pro and completed the initial inspection.',
    timestamp: '10:35 AM',
    type: 'text' as const
  },
  {
    id: '2',
    sender: 'technician' as const,
    message: 'Diagnostic tests show screen damage and battery degradation. I\'ll be replacing both components with genuine Apple parts.',
    timestamp: '11:20 AM',
    type: 'update' as const
  },
  {
    id: '3',
    sender: 'customer' as const,
    message: 'Thank you for the update! How long will the screen replacement take?',
    timestamp: '11:25 AM',
    type: 'text' as const
  },
  {
    id: '4',
    sender: 'technician' as const,
    message: 'The screen replacement typically takes 45-60 minutes. I\'m starting now and will update you with photos of the progress.',
    timestamp: '12:05 PM',
    type: 'text' as const
  }];


  const mockQualityChecks = [
  {
    id: '1',
    name: 'Screen Functionality',
    description: 'Touch responsiveness, display quality, and color accuracy testing',
    status: 'pending' as const
  },
  {
    id: '2',
    name: 'Battery Performance',
    description: 'Charging speed, capacity, and power management verification',
    status: 'pending' as const
  },
  {
    id: '3',
    name: 'Camera & Sensors',
    description: 'All cameras, Face ID, and sensor functionality testing',
    status: 'pending' as const
  },
  {
    id: '4',
    name: 'Connectivity Tests',
    description: 'WiFi, Bluetooth, cellular, and NFC connectivity verification',
    status: 'pending' as const
  },
  {
    id: '5',
    name: 'Physical Inspection',
    description: 'Button responsiveness, port functionality, and build quality check',
    status: 'pending' as const
  },
  {
    id: '6',
    name: 'Software Calibration',
    description: 'iOS optimization, settings restoration, and performance tuning',
    status: 'pending' as const
  }];


  return (
    <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:209:4" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="209" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:210:6" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="210" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrackingHeader data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:211:8" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="211" data-component-file="TrackingInteractive.tsx" data-component-name="TrackingHeader" data-component-content="%7B%22elementName%22%3A%22TrackingHeader%22%7D"
          repairId={repairData.repairId}
          deviceName={repairData.deviceName}
          status={repairData.status} />

        
        <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:217:8" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="217" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-3%20gap-6%20mt-6%22%7D" className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
          <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:218:10" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="218" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%20space-y-6%22%7D" className="lg:col-span-2 space-y-6">
            <ProgressTimeline data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:219:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="219" data-component-file="TrackingInteractive.tsx" data-component-name="ProgressTimeline" data-component-content="%7B%22elementName%22%3A%22ProgressTimeline%22%7D" steps={mockTimelineSteps} />
            <CommunicationPortal data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:220:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="220" data-component-file="TrackingInteractive.tsx" data-component-name="CommunicationPortal" data-component-content="%7B%22elementName%22%3A%22CommunicationPortal%22%7D" messages={mockMessages} />
            <QualityCheckpoints data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:221:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="221" data-component-file="TrackingInteractive.tsx" data-component-name="QualityCheckpoints" data-component-content="%7B%22elementName%22%3A%22QualityCheckpoints%22%7D"
              checks={mockQualityChecks}
              overallStatus="pending" />

          </div>
          
          <div data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:227:10" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="227" data-component-file="TrackingInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
            <TechnicianProfile data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:228:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="228" data-component-file="TrackingInteractive.tsx" data-component-name="TechnicianProfile" data-component-content="%7B%22elementName%22%3A%22TechnicianProfile%22%7D" technician={mockTechnician} />
            <EstimatedCompletion data-component-id="src/app/real-time-tracking/components/TrackingInteractive.tsx:229:12" data-component-path="src/app/real-time-tracking/components/TrackingInteractive.tsx" data-component-line="229" data-component-file="TrackingInteractive.tsx" data-component-name="EstimatedCompletion" data-component-content="%7B%22elementName%22%3A%22EstimatedCompletion%22%7D"
              estimatedTime="2:30 PM"
              confidence={85}
              lastUpdated={currentTime || '12:05 PM'}
              pickupOptions={{
                inStore: true,
                delivery: true,
                estimatedDeliveryTime: 'By 4:00 PM today'
              }} />

          </div>
        </div>
      </div>
    </div>);

};

export default TrackingInteractive;